<template>
  <main class="main main--has-floating-buttons grid--same-height grid--dense">
    <portal v-if="!isEmpty(folios) && !folio.empty" to="headerTitle">
      {{ $t(`folio.title.${folios.parent.type}`, [folios.parent.reservationNumber || folios.parent.guestProfileNumber]) }} / {{ folio.name }}
    </portal>

    <spinner-overlay v-if="creatingPDF" />
    <template v-if="!isEmpty(folios) && !folio.empty">
      <tabable-card id="folio-settings" cols="12 6@tablet 4@desktop">
        <tabable-card-content :title="$t('pageFolio.card.invoiceRecipient')">
          <hm-col :grid="true" cols="12">
            <compact-guest-profile-editor v-model="folio.billingProfileId"
                                          :disabled="!canModifyInvoiceFields"
                                          :search="folios.parent.type !== 'GuestProfile'"
                                          :label="$t('pageFolio.billingProfileId')"
                                          type="Guest" />
          </hm-col>
        </tabable-card-content>
        <tabable-card-content :title="$t('pageFolio.card.additionalInvoiceOptions')" @show="loadBillingGuestProfile">
          <hm-col cols="12">
            <guest-search v-if="folios.parent.type === 'RoomReservation'"
                          ref="guestSearch"
                          :required="true"
                          v-model="folio.primaryGuestProfileId"
                          :disabled="!canModifyInvoiceFields"
                          :label="$t('pageFolio.primaryGuestProfileId')"
                          :help="$t('pageFolio.primaryGuestProfileId_help')" />
            <hm-textarea v-model="folio.comment"
                         :input-rows="2"
                         :disabled="!hasAnyRole(['ROLE_INVOICING', 'ROLE_ADMIN', 'ROLE_SYSADMIN'])"
                         :label="$t('pageFolio.comment')"
                         :help="$t('pageFolio.comment_help')"
                         name="comment" />
            <template v-if="!isEmpty(billingGuestProfile)">
              <hm-select v-model="folio.billingAddressId"
                         :options="billingGuestProfile.addresses"
                         :disabled="!canModifyInvoiceFields"
                         :label="$t('pageFolio.billingAddressId')"
                         label-expression="${option.address}, ${option.zipCode} ${option.city}, ${option.country}"
                         name="billingAddressId"
                         hidden="mobile" />
            </template>
          </hm-col>
          <!--
          <hm-col :grid="true" cols="12">
            <span class="col-12 explanation-text" style="padding-bottom: 1rem;">Wird nicht am Gästeprofil gespeichert. Hat gegenüber einem ausgewählten Rechnungsempfänger und/oder Gast Vorrang.</span>
            <hm-textarea v-model="folio.storedBillingAddress.address" :input-rows="2" label="Name & Anschrift"/>
            <hm-input v-model="folio.storedBillingAddress.zipCode" label="PLZ" name="zipCode" cols="4" hidden="mobile"/>
            <hm-input v-model="folio.storedBillingAddress.city" label="Ort" name="city" cols="8" hidden="mobile"/>
            <hm-select v-model="folio.storedBillingAddress.country" :options="getI18nCountries($i18n.locale)" label="Land" name="country" hidden="mobile"/>
          </hm-col>
          -->
        </tabable-card-content>
      </tabable-card>
      <card v-if="folios.parent.type === 'RoomReservation'" :title="$t('pageFolio.card.reservationDetails')" cols="12 6@tablet 4@desktop">
        <hm-input-date v-model="folios.parent.checkInDate"
                       :disabled="true"
                       :label="$t('pageFolio.checkInDate')"
                       name="checkInDate"
                       cols="6" />
        <hm-input-date v-model="folios.parent.checkOutDate"
                       :disabled="true"
                       :label="$t('pageFolio.checkOutDate')"
                       name="checkOutDate"
                       cols="6" />
        <hm-input :value="$t(`ReservationStatus.${folios.parent.status}`)" :disabled="true" :label="$t('pageFolio.reservationStatus')" name="reservationStatus" />
        <hm-input :value="findHotelSettingById('roomTypes', folios.parent.roomTypeId).name[$shortLocale]" :disabled="true" :label="$t('pageFolio.roomType')" name="roomType" />
        <hm-input :value="findHotelSettingById('ratePlans', folios.parent.ratePlanId).name[$shortLocale]" :disabled="true" :label="$t('pageFolio.ratePlan')" name="ratePlan" />
        <hm-input :value="folios.parent.roomNumber" :disabled="true" :label="$t('pageFolio.roomNumber')" name="roomNumber" />
        <hm-input :value="folios.parent.numAdults"
                  :disabled="true"
                  :label="$t('pageFolio.numAdults')"
                  name="numAdults"
                  cols="6" />
        <hm-input v-if="hasLicense('ChildRates')"
                  :value="folios.parent.numChildren"
                  :disabled="true"
                  :label="$t('pageFolio.numChildren')"
                  name="numChildren"
                  cols="6" />
      </card>

      <card :title="folio.name" cols="12 6@tablet 4@desktop">
        <hm-card-inner :full-size="true">
          <hm-col v-if="folio.editLocked === true" cols="12">
            <span class="info-text info-text--full-size info-text--no-margin col-12"><i class="fal fa-lock"></i>&nbsp;&nbsp;{{ $t('pageFolio.hintFolioLocked') }}</span>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner v-if="!isEmpty(folio.invoiceNumber) || !isEmpty(folio.historicalInvoiceNumbers)" :title="$t('pageFolio.card.invoice')">
          <template v-if="!isEmpty(folio.invoiceNumber) || !isEmpty(folio.historicalInvoiceNumbers)">
            <hm-input v-if="!isEmpty(folio.invoiceNumber)" :value="folio.invoiceNumber" :disabled="true" :label="$t('pageFolio.invoiceNumber')" />
            <hm-input-date v-if="!isEmpty(folio.invoiceDate)" :value="folio.invoiceDate" :disabled="true" :label="$t('pageFolio.invoiceDate')" />
            <hm-input-toggle v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                             :disabled="true"
                             v-model="folio.prepaymentInvoice"
                             label="Deposit Invoice? 🔒"
                             cols="12"
                             name="isFolioPrepaymentInvoice" />
            <hm-button v-if="!isEmpty(folio.invoiceNumber) && !isEmpty(latestInvoiceFileURL)"
                       class="btn--green"
                       cols="12"
                       icon-left="printer"
                       @click="printPDF(latestInvoiceFileURL)">{{ $t('pageFolio.actionPrintInvoice') }}</hm-button>
            <hm-input v-if="!isEmpty(folio.historicalInvoiceNumbers)" :value="folio.historicalInvoiceNumbers" :disabled="true" :label="$t('pageFolio.historicalInvoiceNumbers')" />
            <template v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')">
              <template v-for="invoiceNumber in folio.historicalInvoiceNumbers">
                <hm-input :label="`Regenerate Invoice: ${invoiceNumber} 🔒`" :value="invoiceNumber" :disabled="true" :key="invoiceNumber">
                  <template slot="icon-inline-right" slot-scope="slot">
                    <input-icon-button :border="true" :disabled="false" icon="refresh" @click="regenerateInvoicePdf(invoiceNumber)" />
                  </template>
                </hm-input>
              </template>
            </template>
          </template>
        </hm-card-inner>
        <hm-card-inner v-if="hasLicense('Payments')" :title="$t('pageFolio.card.paymentStatus')">
          <payment-status :payment-status="paymentStatus" />
        </hm-card-inner>
        <hm-card-inner v-if="!isEmpty(folio.comment)" :title="$t('pageFolio.card.internalRemark')">
          <hm-col cols="12">
            <div style="position:relative; margin-bottom: 0.8rem;font-style:italic;">{{ folio.comment }}</div>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner v-if="hasLicense('InterfaceStripe') && hasLicense('StripeTerminal') && hotelSettings.interfaces.stripe.enabled && hotelSettings.interfaces.stripe.terminalEnabled"
                       :title="$t('pageFolio.card.stripeTerminal')">
          <template v-if="hotelSettings.details.countryCode === 'DE' && !hasLicense('EU_DE_Registrierkasse')">
            <span class="warning-text col-12">Die Erfassung von Barzahlungen ist ausschließlich mit aktivierter TSE möglich.</span>
          </template>
          <template v-else>
            <!-- previewTerminal -->
            <hm-button v-if="folio.chargeAmount > 0" class="btn--orange btn--no-margin-bottom" cols="12" icon-left="eye" @click="previewTerminal(stripeTerminalId)">{{ $t('pageFolio.button.previewTerminal') }}</hm-button>
            <!-- cancelTerminal -->
            <hm-button class="btn--red btn--no-margin-bottom" cols="12" icon-left="close" @click="cancelTerminal(stripeTerminalId)">{{ $t('pageFolio.button.clearTerminalDisplay') }}</hm-button>
            <template v-if="canAddPayment && openPaymentAmount > 0 && isEmpty(activePaymentProcess.payments)">
              <!-- requestPayment -->
              <hm-button class="btn--green btn--no-margin-bottom" cols="12" icon-left="credit-card" @click="requestPayment(stripeTerminalId)">{{ $t('pageFolio.button.requestPayment') }}</hm-button>
            </template>
          </template>
        </hm-card-inner>
      </card>

      <card v-if="hasActivePaymentRequest"
            v-show="!isEmpty(activePaymentRequest)"
            :title="$t('pageFolio.card.activePaymentProcess')"
            cols="12">
        <template v-if="!isEmpty(activePaymentRequest)">
          <hm-card-inner :full-size="true">
            <hm-table id="active-payment-request" :hover="false" columns="5" min-width="700px" grid-template-columns="5rem 3fr 1fr 1fr 15rem">
              <div class="hm-table__th">{{ $t('table.activePaymentRequest.status') }}</div>
              <div class="hm-table__th">{{ $t('table.activePaymentRequest.folio') }}</div>
              <div class="hm-table__th text-right">{{ $t('table.activePaymentRequest.amount') }}</div>
              <div class="hm-table__th text-right">{{ $t('table.activePaymentRequest.total') }}</div>
              <div class="hm-table__th text-right">{{ $t('table.activePaymentRequest.actions') }}</div>
              <template slot="default">
                <template v-for="(payment, index) in activePaymentRequest.folioPaymentDetails">
                  <div class="hm-table__td" v-if="['Initial','Prepared'].includes(activePaymentRequest.status)"><i class="fa-thin fa-credit-card"></i></div>
                  <div class="hm-table__td" v-else-if="payment.posted === false"><i class="fa-duotone fa-solid fa-spinner fa-spin"></i></div>
                  <div class="hm-table__td" v-else><i class="fa-thin fa-check"></i></div>
                  <div class="hm-table__td">{{ $t(`folio.title.${payment.folioIdentifier.parentId.type}`, [id2number(payment.folioIdentifier.parentId.id)]) }}</div>
                  <div class="hm-table__td text-right">{{ payment.amount | toCurrency }} {{ payment.currency }}</div>
                  <div class="hm-table__td text-right">&nbsp;</div>
                  <div class="hm-table__td text-right">&nbsp;</div>
                </template>
                <div class="hm-table__td" v-if="['Initial','Prepared'].includes(activePaymentRequest.status)"><i class="fa-thin fa-credit-card"></i></div>
                <div class="hm-table__td" v-else-if="['InProgress'].includes(activePaymentRequest.status)"><i class="fa-duotone fa-solid fa-spinner fa-spin"></i></div>
                <div class="hm-table__td" v-else-if="['Complete'].includes(activePaymentRequest.status)"><i class="fa-thin fa-check"></i></div>
                <div class="hm-table__td" v-else></div>
                <div class="hm-table__td text--bold">{{ $t('table.activePaymentRequest.summaryTotal') }}</div>
                <div class="hm-table__td text-right"></div>
                <div class="hm-table__td text--bold text-right">{{ activePaymentRequest.amount | toCurrency }} {{ activePaymentRequest.currency }}</div>
                <div class="hm-table__td hm-table__td--icon">
                  <span v-if="['Initial','Prepared'].includes(activePaymentRequest.status)"
                        v-tooltip="{ title: $t('table.activePaymentRequest.cancelPaymentRequest'), delay: 250, placement: 'bottom', positionFixed: true, trigger: 'hover', touch: false }"
                        class="quick-action-button"
                        @click="cancelPaymentRequest(folio.editLockKey)">
                    <icon icon="delete" />
                  </span>
                </div>
              </template>
            </hm-table>
          </hm-card-inner>
          <hm-card-inner :full-size="true" v-if="activePaymentRequest.status === 'Complete'">
            <hm-col cols="12">
              <span class="info-text info-text--full-size info-text--no-margin col-12">Zahlung erfolgreich! Warten auf Zahlungsbeleg ...</span>
            </hm-col>
          </hm-card-inner>
        </template>
      </card>

      <card v-if="hasLicense('Payments')"
            v-show="!isEmpty(activePaymentProcess.payments)"
            :title="$t('pageFolio.card.activePaymentProcess')"
            cols="12"
            min-height="18.5rem">
        <hm-card-inner v-if="!isEmpty(activePaymentProcess.payments)" :full-size="true">
          <active-payment-process :can-finish-payment-process="canFinishPaymentProcess" :can-add-as-prepayment="canAddAsPrepayment" :balance="openPaymentAmount" :payment-process="activePaymentProcess">
            <template slot="b1" slot-scope="props">
              <span class="quick-action-button" @click="onClickEditPaymentTransaction(props.paymentTransaction)">
                <icon icon="edit" />
              </span>
            </template>
            <template slot="b2" slot-scope="props">
              <span class="quick-action-button" @click="removeDraftPaymentTransaction(props.paymentTransaction)">
                <icon icon="delete" />
              </span>
            </template>
          </active-payment-process>
          <hm-card-inner-inner>
            <hm-col :grid="true" class="row-gap" cols="12">
              <hm-button :disabled="!canAddAsPrepayment"
                         class="btn--green btn--no-margin"
                         cols="12 6@tablet 3@desktop 2@hd start-7@desktop start-9@hd"
                         icon-left="pre-payment"
                         @click="addPrePayment">{{ $t('pageFolio.button.finishPrePayment') }}</hm-button>
              <hm-button :disabled="!canFinishPaymentProcess"
                         class="btn--green btn--no-margin"
                         cols="12 6@tablet 3@desktop 2@hd"
                         icon-left="save"
                         @click="addPayment">{{ $t('pageFolio.button.finishPayment') }}</hm-button>
            </hm-col>
          </hm-card-inner-inner>
        </hm-card-inner>
      </card>

      <template v-if="hotelSettings.details.countryCode === 'DE' || hasRole('ROLE_SYSADMIN')">
        <card v-if="!isEmpty(receipts) || folio.receiptStatus !== 'Ready'" :title="$t('pageFolio.card.receipts')" cols="12">
          <hm-card-inner v-if="folio.receiptStatus !== 'Ready'">
            <hm-col cols="12">
              Belege werden verarbeitet ...
            </hm-col>
          </hm-card-inner>
          <hm-card-inner v-if="!isEmpty(receipts)" :full-size="true">
            <hm-table :hover="false"
                      :sticky="true"
                      columns="4"
                      grid-template-columns="minmax(7rem, max-content) max-content auto  minmax(4.7rem, max-content)"
                      min-width="40rem">
              <template slot="table-head">
                <div class="hm-table__th">{{ $t('pageFolio.receipts.number') }}</div>
                <div class="hm-table__th">{{ $t('pageFolio.receipts.dateTime') }}</div>
                <div class="hm-table__th">{{ $t('pageFolio.receipts.type') }}</div>
                <div class="hm-table__th"></div>
              </template>
              <template v-for="(receipt, idx) in receipts">
                <div class="hm-table__td">
                  {{ receipt.additionalFields.ftReceiptIdentification }}
                </div>
                <div class="hm-table__td">
                  <template v-if="['DE'].includes(hotelSettings.details.countryCode)">{{ receipt.receiptDateTime | toLocalDateTime }}</template><!-- UTC countries -->
                  <template v-else>{{ receipt.receiptDateTime | toDateTime }}</template><!-- other countries -->
                </div>
                <div class="hm-table__td">
                  <template v-if="receipt.flags.includes('InvoiceReceipt') && receipt.flags.includes('PaymentReceipt') && !receipt.flags.includes('CancellationReceipt')">
                    Zahlung
                  </template>
                  <template v-if="receipt.flags.includes('InvoiceReceipt') && !receipt.flags.includes('PaymentReceipt') && !receipt.flags.includes('CancellationReceipt')">
                    <template v-if="receipt.charges.map(it => it.amount).reduce((a, b) => a+b, 0) !== receipt.payments.map(it => it.amount).reduce((a, b) => a+b, 0)">
                      Forderungsentstehung
                    </template>
                    <template v-else-if="receipt.charges.filter(it => it.code.id === '00000000-0000-0000-0000-000000000000').length > 0"> <!-- required because of charge item for receivable creation -->
                      Forderungsentstehung
                    </template>
                    <template v-else>
                      Rechnung
                    </template>
                  </template>
                  <template v-if="!receipt.flags.includes('InvoiceReceipt') && receipt.flags.includes('PaymentReceipt') && !receipt.flags.includes('CancellationReceipt')">
                    <template v-if="hotelSettings.details.countryCode === 'DE'">
                      Forderungsauflösung
                    </template>
                    <template v-else>
                      Zahlung
                    </template>
                  </template>
                  <template v-if="receipt.flags.includes('CancellationReceipt')">
                    Storno
                  </template>
                  <pre class="hidden" v-html="receipt"></pre>
                </div>
                <div class="hm-table__td hm-table__td--icon">
                  <span class="quick-action-button" @click="printReceipt(folioId, idx)">
                    <icon icon="printer"/>
                  </span>
                </div>
              </template>
            </hm-table>
          </hm-card-inner>
        </card>
      </template>

      <tabable-card v-if="hasLicense('Payments')"
                    v-show="!isEmpty(folio.payments) || !isEmpty(folio.cancelledPayments)"
                    id="payments"
                    cols="12"
                    min-height="15rem">
        <tabable-card-content :title="$t('pageFolio.card.closedPaymentTransactions')" :center="isEmpty(folio.payments)">
          <hm-card-inner v-if="!isEmpty(folio.payments)" :full-size="true">
            <payment-table :payments="folio.payments" :created="true">
              <template slot="b1" slot-scope="props">
                <span v-tooltip="{ title: $t('pageFolio.printPaymentReceipt'), delay: 250, placement: 'top', positionFixed: true, trigger: 'hover', touch: false }" v-if="!isEmpty(props.paymentProcess.receiptHolderId)" class="quick-action-button" @click="printReceipt(props.paymentProcess.receiptHolderId, 0)">
                  <icon icon="bon" />
                </span>
              </template>
              <template slot="b2" slot-scope="props">
                <span v-if="canDeletePayment" class="quick-action-button" @click="deletePayment(props.paymentProcess.id)">
                  <icon icon="delete" />
                </span>
              </template>
            </payment-table>
          </hm-card-inner>
          <hm-card-inner v-else>
            <card-action v-if="canAddPayment" :title="$t('pageFolio.cardActionAddPayment')" @click="showCreatePaymentModal = true" />
            <hint v-else :text="$t('pageFolio.hintFolioLocked')" icon="lock" />
          </hm-card-inner>
        </tabable-card-content>
        <tabable-card-content :title="$t('pageFolio.card.cancelledPaymentTransactions')">
          <hm-card-inner v-if="!isEmpty(folio.cancelledPayments)" :full-size="true">
            <payment-table :payments="folio.cancelledPayments" :created="true" :cancelled="true">
              <template slot="b1" slot-scope="props">
                <span v-tooltip="{ title: $t('pageFolio.printPaymentReceipt'), delay: 250, placement: 'top', positionFixed: true, trigger: 'hover', touch: false }" v-if="!isEmpty(props.paymentProcess.receiptHolderId)" class="quick-action-button" @click="printReceipt(props.paymentProcess.receiptHolderId, 0)">
                  <icon icon="bon" />
                </span>
              </template>
              <template slot="b2" slot-scope="props">
                <span v-tooltip="{ title: $t('pageFolio.printPaymentCancellationReceipt'), delay: 250, placement: 'top', positionFixed: true, trigger: 'hover', touch: false }" v-if="!isEmpty(props.paymentProcess.receiptHolderId)" class="quick-action-button" @click="printReceipt(props.paymentProcess.receiptHolderId, 1)">
                  <icon icon="bon-cancelled" />
                </span>
              </template>
            </payment-table>
          </hm-card-inner>
          <hm-card-inner v-else>
            <hint :text="$t('pageFolio.hintNoCancelledPaymentTransactions')" />
          </hm-card-inner>
        </tabable-card-content>
      </tabable-card>

      <transaction-transfer-view v-if="transferMode && showTransferModeButton && canTransfer"
                                 :transactions="folio.transactions"
                                 :folios="folios.folios"
                                 :parent-id="parentId"
                                 :reservation="reservation"
                                 :folio-id="folio.id" />

      <tabable-card v-if="!transferMode || !showTransferModeButton" id="transactions" cols="12 8@hd" min-height="19rem">
        <tabable-card-content :title="$t('pageFolio.card.charges')" :center="isEmpty(folio.transactions)">
          <hm-card-inner v-if="!isEmpty(folio.transactions)" :full-size="true">
            <transaction-table :transactions="folio.transactions"
                               :created="true"
                               :draggable="canTransfer"
                               :parent-id="parentId"
                               :folio-id="folio.id">
              <template
                v-if="canAddCharge
                  && props.transaction.code.type === 'InHouseService'
                  && hotelSettings.inHouseServices.all().filter(it => it.type === 'PrePayment').filter(it => it.id === props.transaction.code.id).length > 0
                "
                slot="b1"
                slot-scope="props">
                <span :title="$t('pageFolio.charges.actionSplit')" class="quick-action-button" @click="splitTransaction=props.transaction">
                  <icon icon="split" />
                </span>
              </template>
              <template v-if="canAddCharge && props.transaction.code.type !== 'TransactionGroup' && (props.transaction.locked !== true || hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN'))" slot="b2" slot-scope="props">
                <span :title="$t('pageFolio.charges.actionEdit')" class="quick-action-button" @click="editTransaction=props.transaction">
                  <icon icon="edit" />
                </span>
              </template>
              <template v-if="canAddCharge && props.transaction.locked !== true" slot="b3" slot-scope="props">
                <span :title="$t('pageFolio.charges.actionDelete')" class="quick-action-button" @click="cancelTransaction(props.transaction.id)">
                  <icon icon="delete" />
                </span>
              </template>
            </transaction-table>
          </hm-card-inner>
          <hm-card-inner v-else>
            <card-action v-if="canAddCharge" :title="$t('pageFolio.cardActionAddCharge')" @click="showCreateTransactionModal = true" />
            <hint v-else :text="$t('pageFolio.hintFolioLocked')" icon="lock" />
          </hm-card-inner>
        </tabable-card-content>
        <tabable-card-content :display="!isEmpty(folio.cancelledTransactions)" :title="$t('pageFolio.card.cancelledCharges')">
          <hm-card-inner :full-size="true">
            <hm-col v-if="!canAddCharge" cols="12">
              <span class="info-text info-text--full-size col-12" v-html="$t('pageFolio.infoRestoreToPrimary')"></span>
            </hm-col>
            <transaction-table :transactions="folio.cancelledTransactions" :cancelled="true" :restored="true">
              <template slot="b1" slot-scope="props">
                <span v-if="isEmpty(props.transaction.restoredAt) && props.transaction.locked !== true" class="quick-action-button" @click="undoCancelTransaction(props.transaction.id)">
                  <icon icon="undo" />
                </span>
              </template>
            </transaction-table>
          </hm-card-inner>
        </tabable-card-content>
        <tabable-card-content :display="!isEmpty(folio.transferredTransactions)" :title="$t('pageFolio.card.transferredCharges')">
          <hm-card-inner :full-size="true">
            <transferred-transaction-table :transactions="folio.transferredTransactions" :created="true" :parent-id="parentId" :folios="folios.folios"/>
          </hm-card-inner>
        </tabable-card-content>
      </tabable-card>

      <transaction-transfer-view v-if="isHD && !showTransferModeButton && canTransfer"
                                 :transactions="folio.transactions"
                                 :folios="folios.folios"
                                 :parent-id="parentId"
                                 :reservation="reservation"
                                 :folio-id="folio.id" />

      <card :cols="`12 4@hd ${folios.parent.type === 'RoomReservation' ? 'start-9@hd' : 'start-5@hd'}`" :rows="`${folios.parent.type === 'RoomReservation' ? '1' : '1 start-1@hd'}`" :title="$t('pageFolio.card.invoiceOptions')">
        <hm-textarea v-model="folio.invoiceTextTop"
                     :input-rows="2"
                     :disabled="!canModifyInvoiceFields"
                     :label="$t('pageFolio.invoiceTextTop')"
                     :help="$t('pageFolio.invoiceTextTop_help')"
                     name="invoiceTextTop"
                     cols="12 6@tablet 12@hd" />
        <hm-textarea v-model="folio.invoiceTextBottom"
                     :input-rows="2"
                     :disabled="!canModifyInvoiceFields"
                     :label="$t('pageFolio.invoiceTextBottom')"
                     :help="$t('pageFolio.invoiceTextBottom_help')"
                     name="invoiceTextBottom"
                     cols="12 6@tablet 12@hd" />
      </card>

      <correspondence-table v-if="!isEmpty(files)" :correspondence="files" cols="12 8@hd start-1@hd" />
    </template>

    <modal v-if="splitTransaction !== null"
           :close-on-click-outside="false"
           :hide-on-submit="false"
           :title="$t('pageFolio.card.splitCharge')"
           :confirm-label="$t('pageFolio.confirmSplitCharge')"
           @confirm="doSplitTransaction()"
           @cancel="splitTransaction=null">
      <hm-card-inner :full-size="true">
        <span class="info-text info-text--full-size info-text--no-margin col-12">{{ $t('pageFolio.hintSplitTransaction') }}</span>
      </hm-card-inner>
      <hm-card-inner min-height="35.8rem">
        <transaction-split ref="splitTransaction" :transaction="splitTransaction" />
      </hm-card-inner>
    </modal>

    <modal v-if="editTransaction !== null"
           :close-on-click-outside="false"
           :hide-on-submit="false"
           :title="$t('pageFolio.card.editCharge')"
           :confirm-label="$t('pageFolio.confirmEditCharge')"
           @confirm="updateTransaction()"
           @cancel="editTransaction=null">
      <hm-card-inner min-height="35.8rem">
        <transaction-editor ref="updateTransaction" :reservation="reservation" :transaction="editTransaction" />
      </hm-card-inner>
    </modal>

    <modal v-if="showCreateTransactionModal"
           :close-on-click-outside="false"
           :hide-on-submit="false"
           :title="$t('pageFolio.card.addCharge')"
           :confirm-label="$t('pageFolio.confirmAddCharge')"
           @confirm="addTransaction()"
           @cancel="showCreateTransactionModal=false">
      <hm-card-inner min-height="35.8rem">
        <transaction-editor ref="createTransaction" :reservation="reservation" />
      </hm-card-inner>
    </modal>

    <modal v-if="editPaymentTransaction !== null"
           :close-on-click-outside="false"
           :hide-on-submit="false"
           :title="$t('pageFolio.card.editPayment')"
           :confirm-label="$t('pageFolio.confirmEditPayment')"
           @confirm="confirmEditPayment()"
           @cancel="editPaymentTransaction=null">
      <hm-card-inner min-height="35.8rem">
        <payment-editor ref="updatePayment" :reservation="reservation" :payment="editPaymentTransaction" />
      </hm-card-inner>
    </modal>

    <modal v-if="showCreatePaymentModal"
           :close-on-click-outside="false"
           :hide-on-submit="false"
           :title="$t('pageFolio.card.addPayment')"
           :confirm-label="$t('pageFolio.confirmAddPayment')"
           @confirm="addPaymentTransaction()"
           @cancel="showCreatePaymentModal=false">
      <hm-card-inner min-height="35.8rem">
        <payment-editor ref="createPayment" :reservation="reservation" :amount="openPaymentAmount" />
      </hm-card-inner>
    </modal>

    <modal v-if="showSelectPrePaymentIhsId"
           :close-on-click-outside="false"
           :hide-on-submit="true"
           :title="$t('pageFolio.card.selectPrePaymentTax')"
           :button2-disabled="() => isEmpty(prePaymentIhsId)"
           @destroy="showSelectPrePaymentIhsId = false"
           @confirm="finishPrePayment">
      <hm-card-inner>
        <hm-col :grid="true" cols="12">
          <span v-if="canFinishPaymentProcess && openPaymentAmount === 0" class="warning-text col-12">{{ $t('pageFolio.hintPaymentAmountMatchesOpenBalance') }}</span>
          <span v-if="sumBy(activePaymentProcess.payments, 'amount') < 0" class="warning-text col-12">{{ $t('pageFolio.hintPaymentAmountNegative') }}</span>
          <hm-input-select v-model="prePaymentIhsId" :label="$t('pageFolio.prePaymentIhsId')" name="prePaymentIhsId">
            <option v-for="item in hotelSettings.inHouseServices.all(prePaymentIhsId)" v-if="item.type === 'PrePayment'" :value="item.id" v-html="item.name[$shortLocale]"></option>
          </hm-input-select>
        </hm-col>
      </hm-card-inner>
    </modal>

    <modal v-if="showPrePaymentInvoice"
           :close-on-click-outside="false"
           :hide-on-submit="true"
           :title="$t('pageFolio.card.createPrePaymentInvoice')"
           :button2-disabled="() => isEmpty(prePaymentInvoice.ihsId) || prePaymentInvoice.amount === 0"
           @destroy="showPrePaymentInvoice = false"
           @confirm="finishPrePaymentInvoice">
      <hm-card-inner>
        <hm-col cols="12">
          <span class="info-text col-12" v-html="$t('pageFolio.infoPrePaymentInvoice')"></span>
        </hm-col>
        <hm-col :grid="true" cols="12">
          <hm-input-select v-model="prePaymentInvoice.ihsId" :label="$t('pageFolio.prePaymentInvoice.ihsId')" name="prePaymentInvoiceIhsId">
            <option v-for="item in hotelSettings.inHouseServices.all(prePaymentInvoice.ihsId)" v-if="item.type === 'PrePayment'" :value="item.id" v-html="item.name[$shortLocale]"></option>
          </hm-input-select>
          <hm-input v-model="prePaymentInvoice.label" :label="$t('pageFolio.prePaymentInvoice.label')" name="prePaymentInvoiceLabel" />
          <hm-input-money v-model="prePaymentInvoice.amount"
                          :currency="hotelSettings.details.currency"
                          :label="$t('pageFolio.prePaymentInvoice.amount')"
                          required
                          validate="required"
                          name="prePaymentInvoiceAmount" />
          <hm-textarea v-model="prePaymentInvoice.invoiceTextBottom" :label="$t('pageFolio.prePaymentInvoice.invoiceTextBottom')" name="prePaymentInvoiceInvoiceTextBottom" />
        </hm-col>
      </hm-card-inner>
    </modal>

    <hm-floating-buttons v-if="!isEmpty(folios) && !folio.empty" ref="floatingButtons">
      <template v-if="folio.editLocked === true">
        <hm-floating-button :label="`${$t('pageFolio.actions.unlockFolio')} 🔒`"
                            v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                            icon="unlock"
                            color="orange"
                            @click="unlockFolio" />
      </template>
      <template v-if="showTransferModeButton">
        <hm-floating-button v-if="!isEmpty(folio.transactions) && canTransfer && transferMode === false"
                            :label="$t('pageFolio.actions.enableTransferMode')"
                            icon="transfer"
                            color="orange"
                            @click="transferMode = true" />
      </template>
      <hm-floating-button v-if="transferMode === true"
                          :label="$t('pageFolio.actions.disableTransferMode')"
                          icon="delete"
                          color="orange"
                          @click="transferMode = false" />
      <hm-floating-button v-if="canCreateDraftInvoice"
                          :label="$t('pageFolio.actions.createDraftInvoice')"
                          icon="pdf"
                          color="gray"
                          @click="createPDF" />
      <hm-floating-button :label="$t('pageFolio.actions.more')" icon="plus" color="blue">
        <hm-floating-child-button v-if="folios.parent.type === 'RoomReservation'"
                                  :label="$t('pageFolio.actions.createEmail')"
                                  icon="plus"
                                  color="blue"
                                  @click="createEmail" />
        <hm-floating-child-button v-else
                                  :label="$t('pageFolio.actions.createEmail')"
                                  icon="plus"
                                  color="blue"
                                  @click="$router.push({ name: 'guestFolioEmail', params: $route.params})" />
        <hm-floating-child-button v-if="canAddCharge"
                                  :label="$t('pageFolio.actions.createPrePaymentInvoice')"
                                  icon="plus"
                                  color="blue"
                                  @click="showPrePaymentInvoice = true" />
        <hm-floating-child-button v-if="hasAnyRole(['ROLE_INVOICING', 'ROLE_ADMIN', 'ROLE_SYSADMIN'])"
                                  :label="$t('pageFolio.actions.addFolio')"
                                  :disabled="folioCount >= 50"
                                  icon="plus"
                                  color="blue"
                                  @click="addFolio" />
        <hm-floating-child-button v-if="canAddPayment && hasLicense('InterfaceStripe') && hasLicense('StripeTerminal') && hotelSettings.interfaces.stripe.enabled && hotelSettings.interfaces.stripe.terminalEnabled && openPaymentAmount > 0 && isEmpty(activePaymentProcess.payments)"
                                  :label="$t('pageFolio.actions.requestPayment')"
                                  icon="plus"
                                  color="blue"
                                  @click="requestPayment" />
        <hm-floating-child-button v-if="canAddCharge"
                                  :label="$t('pageFolio.actions.addCharge')"
                                  icon="plus"
                                  color="blue"
                                  @click="showCreateTransactionModal = true" />
        <hm-floating-child-button v-if="canAddPayment"
                                  :label="$t('pageFolio.actions.addPayment')"
                                  icon="plus"
                                  color="blue"
                                  @click="showCreatePaymentModal = true" />
      </hm-floating-button>
      <hm-floating-button v-if="canCancelInvoice"
                          :label="$t('pageFolio.actions.cancelInvoice')"
                          icon="delete"
                          color="error"
                          @click="cancelInvoice " />
      <hm-floating-button v-else-if="!canCancelInvoice && canFinishPaymentProcess"
                          :disabled="!canCreateInvoice"
                          :label="$t('pageFolio.actions.finishPaymentAndCreateInvoice')"
                          icon="save"
                          color="mint"
                          @click="addPaymentCreateInvoice" />
      <hm-floating-button v-else
                          :disabled="!canCreateInvoice"
                          :label="$t('pageFolio.actions.createInvoice')"
                          icon="save"
                          color="mint"
                          @click="createInvoice" />
    </hm-floating-buttons>
  </main>
</template>


<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import {
  isArray,
  join,
  isNil,
  isEmpty,
  groupBy,
  values,
  head,
  cloneDeep,
  concat,
  unionBy,
  reverse,
  sortBy,
  last,
  sum,
  isBoolean, sumBy,
} from 'lodash';
import HmCardInnerLine from '../lib/layout/HmCardInnerLine';
import HmCardInner from '../lib/layout/HmCardInner';
import uuid from 'uuid';
import HmCol from '../lib/layout/HmCol';
import HmInput from '../lib/inputs/HmInput';
import ContenteditableDiv from '../lib/util/ContenteditableDiv';
import NotificationMixin from '../../mixins/NotificationMixin';
import HmTable from '../lib/table/HmTable';
import TabableCard from '../lib/layout/TabableCard';
import TabableCardContent from '../lib/layout/TabableCardContent';
import PaymentStatus from '../lib/util/PaymentStatus';
import FilterMixin from '../../mixins/FilterMixin';
import CorrespondenceTable from '../lib/table/CorrespondenceTable';
import TransactionTable from '../lib/table/TransactionTable';
import TransactionEditor from '../lib/folios/TransactionEditor';
import SaveWatchMixin from '../../mixins/SaveWatchMixin';
import SpinnerOverlay from '../lib/util/SpinnerOverlay';
import TransferTransactionTable from '../lib/table/TransferTransactionTable';
import TimerMixin from '../../mixins/TimerMixin';
import hotelSettingsMixin from '../../mixins/HotelSettingsMixin';
import HmButton from '../lib/buttons/HmButton.vue';

export default {
  name: 'PageFolio',
  components: { HmButton, TransferTransactionTable, SpinnerOverlay, TransactionEditor, TransactionTable, CorrespondenceTable, PaymentStatus, TabableCardContent, TabableCard, HmTable, ContenteditableDiv, HmCardInner, HmInput, HmCol },

  mixins: [HotelmeisterMixin, NotificationMixin, FilterMixin, SaveWatchMixin, TimerMixin],

  autosave: [
    {
      name: 'folio',
      variable: 'folio',
      fn: function (cbSaveComplete) {
        this.axios.put(this.serviceUrls.folio.get(this, this.parentId, this.folioId), this.folio)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
      include: [
        'invoiceTextTop',
        'invoiceTextBottom',
        'billingProfileId',
        'billingAddressId',
        'comment',
        'primaryGuestProfileId',
        'storedBillingAddress',
      ],
    },
  ],

  data() {
    return {
      receipts: [],
      folios: {},
      folio: {
        invoiceNumber: null,
        transactions: [],
        locked: false,
        payments: [],
        empty: true, // used for if statements
        receiptStatus: 'Ready',
      },
      activePaymentRequest: null,
      activePaymentRequestUpdateTimer: null,
      reservation: null,
      paymentStatus: {},
      files: [],
      billingGuestProfile: null,
      showCreateTransactionModal: false,
      showCreatePaymentModal: false,
      editTransaction: null,
      latestInvoiceFileURL: null,
      latestDraftInvoiceFileURL: null,
      creatingPDF: false,
      activePaymentProcess: {
        id: uuid.v4(),
        payments: [],
      },
      prePaymentInvoice: {
        ihsId: null,
        label: null,
        amount: 0.0,
        currency: null,
        invoiceTextBottom: null,
      },
      editPaymentTransaction: null,
      showSelectPrePaymentIhsId: false,
      showPrePaymentInvoice: false,
      prePaymentIhsId: null,
      transferMode: false,
      folioId: null,
      updateReceiptStatusInterval: null,
      splitTransaction: null,
      stripeTerminalId: null,
    };
  },

  computed: {
    hotelSettingsMixin() {
      return hotelSettingsMixin
    },
    hasActivePaymentRequest() {
      return !isEmpty(this.folio.editLockKey) && this.folio.editLockKey.includes('::paymentreq::');
    },
    isHD: function () {
      return this.$store.getters['layout/activeBreakpoint'] === 'hd';
    },
    showTransferModeButton: function () {
      return this.$store.getters['layout/activeBreakpoint'] === 'desktop';
    },
    parentId: function () {
      return this.$route.params.reservationId || this.$route.params.guestProfileId;
    },
    canModifyInvoiceFields: function () {
      return this.canCreateInvoice || this.canAddCharge;
    },
    canCreateInvoice: function () {
      if (!isEmpty(this.folio.invoiceNumber)) {
        return false;
      }

      if (isEmpty(this.folio.transactions)) {
        return false;
      }

      if (this.folio.receiptStatus !== 'Ready') {
        return false;
      }

      if (this.folio.locked === true) {
        return false;
      }

      if (this.folio.editLocked === true) return false;

      if (this.folio.number === 0 && this.folioCount >= 50) return false;

      return true;
    },
    canCreateDraftInvoice: function () {
      if (this.canCreateInvoice) return true;

      if (this.hasRole('ROLE_SYSADMIN')) {
        if (!isEmpty(this.folio.invoiceNumber)) return true;
      }

      return false;
    },
    canTransfer: function () {
      return this.canAddCharge;
    },
    canAddCharge: function () {
      if (!this.hasAnyRole(['ROLE_INVOICING', 'ROLE_ADMIN', 'ROLE_SYSADMIN'])) return false;

      if (!isEmpty(this.folio.invoiceNumber)) {
        return false;
      }

      if (this.folio.receiptStatus !== 'Ready') {
        return false;
      }

      if (this.folio.locked === true) return false;

      if (this.folio.noPost === true) return false;

      if (this.folio.editLocked === true) return false;

      switch (this.hotelSettings.details.countryCode) {
        case 'AT':
          return isEmpty(this.folio.payments);
        case 'DE':
          if (this.hasLicense('EU_DE_Registrierkasse')) return isEmpty(this.folio.payments);
          else break;
        default:
          break;
      }

      return true;
    },
    canDeletePayment: function () {
      if (this.folio.receiptStatus !== 'Ready') {
        return false;
      }

      if (this.folio.editLocked === true) return false;

      if (this.folio.status === 'Storno' && !this.hasRole('ROLE_SYSADMIN')) return false;

      switch (this.hotelSettings.details.countryCode) {
        case 'AT':
          return true;
        case 'DE':
          if (this.hasLicense('EU_DE_Registrierkasse')) return this.canCancelInvoice;
          else return true;
        default:
          return true;
      }
    },
    canCancelInvoice: function () {
      if (isEmpty(this.folio.invoiceNumber)) {
        return false;
      }

      if (this.folio.receiptStatus !== 'Ready') {
        return false;
      }

      if (this.folio.status === 'Storno' && this.hasRole('ROLE_SYSADMIN')) return true;

      if (this.folio.editLocked === true) return false;

      return true;
    },
    canAddPayment: function () {
      if (!this.hasAnyRole(['ROLE_INVOICING', 'ROLE_ADMIN', 'ROLE_SYSADMIN'])) return false;

      if (!this.hasLicense('Payments')) return false;

      if (this.folio.receiptStatus !== 'Ready') {
        return false;
      }

      if (this.folio.editLocked === true) return false;

      switch (this.hotelSettings.details.countryCode) {
        case 'AT': return isEmpty(this.folio.payments);
        case 'DE':
          if (this.hasLicense('EU_DE_Registrierkasse')) {
            if (isEmpty(this.folio.transactions) && this.folio.noPost === true) return false;
            return isEmpty(this.folio.payments);
          } else {
            return true;
          }
        default: return true;
      }
    },
    canFinishPaymentProcess: function () {
      if (this.folio.receiptStatus !== 'Ready') {
        return false;
      }

      if (this.folio.number === 0 && this.folioCount >= 50) return false;

      if (this.folio.editLocked === true) return false;

      switch (this.hotelSettings.details.countryCode) {
        case 'AT':
          return !isEmpty(this.activePaymentProcess.payments) && this.openPaymentAmount === 0;
        case 'DE':
          if (this.hasLicense('EU_DE_Registrierkasse')) {
            return !isEmpty(this.activePaymentProcess.payments) && this.openPaymentAmount === 0;
          } else {
            return !isEmpty(this.activePaymentProcess.payments);
          }
        default:
          return !isEmpty(this.activePaymentProcess.payments);
      }
    },
    canAddAsPrepayment: function () {
      if (this.folio.receiptStatus !== 'Ready') {
        return false;
      }

      if (this.folioCount >= 50) return false;

      if (this.folio.editLocked === true) return false;

      switch (this.hotelSettings.details.countryCode) {
        case 'AT':
          return !isEmpty(this.activePaymentProcess.payments) && this.canAddCharge;
        case 'DE':
          if (this.hasLicense('EU_DE_Registrierkasse')) {
            return !isEmpty(this.activePaymentProcess.payments) && this.canAddCharge;
          } else {
            return this.canAddCharge;
          }
        default:
          return this.canAddCharge;
      }
    },
    openPaymentAmount: function () {
      if (isNil(this.paymentStatus)) return 0;

      let ret = (this.paymentStatus.balance * -1) - sum(this.activePaymentProcess.payments.map(it => it.amount));
      ret = Object.is(ret, -0) ? 0 : ret;

      // fallback for floating point issues up to 3 decimal place precision
      if (ret !== 0 && Number.parseFloat(this.paymentStatus.balance * -1).toFixed(3) === Number.parseFloat(sum(this.activePaymentProcess.payments.map(it => it.amount))).toFixed(3)) {
        ret = 0;
      }

      return ret;
    },
    folioCount: function () {
      try {
        return this.folios.folios.length;
      } catch (e) {
        return 0;
      }
    },
  },

  watch: {
    hasActivePaymentRequest: function (newVal) {
      const doesCreateInvoice = this.hotelSettings.details.countryCode === 'AT' || (this.hotelSettings.details.countryCode === 'DE' && this.hasLicense('EU_DE_Registrierkasse'));

      if (newVal === true) {
        this.updatePaymentRequest(this.folio.editLockKey);
        this.activePaymentRequestUpdateTimer = this.setInterval(() => {
          if (!isNil(this.folio)) this.updatePaymentRequest(this.folio.editLockKey)
        }, 2500);
      } else {
        if (!isNil(this.activePaymentRequest)) {
          this.updateFolio();
          this.updateFolios();
          this.updateFolioFiles().then((resp) => {
            if (doesCreateInvoice) {
              this.printPDF(this.getLatestInvoiceFileURL('Final'));
            }
          });
        }
        this.activePaymentRequest = null;
        this.clearInterval(this.activePaymentRequestUpdateTimer);
      }
    },
    files: {
      handler: function () {
        if (isNil(this.files)) {
          this.latestInvoiceFileURL = null;
          this.latestInvoiceFileURL = null;
          return;
        }

        this.latestInvoiceFileURL = this.getLatestInvoiceFileURL('Final');
        this.latestDraftInvoiceFileURL = this.getLatestInvoiceFileURL('Draft');
      },
      deep: true,
    },
    'folio.receiptStatus': function (newVal) {
      if (newVal !== 'Ready') {
        this.updateReceiptStatusInterval = this.setInterval(() => {
          this.updateFolio();
        }, 5000);
      } else {
        this.clearInterval(this.updateReceiptStatusInterval);
        this.updateFolioFiles();

        this.setTimeout(this.updateFolioFiles, 2500);
      }
    },
  },

  created: function () {
    this.folioId = this.$route.params.folioId;
    this.stripeTerminalId = this.getUserConfig('stripeTerminalId', true) || null;

    this.$serviceBus.$on('folio.list', (data) => {
      this.folios = data.data;
      if (!isEmpty(this.folios.parent.roomChargeInvoiceRecipientId)) {
        this.updateAdditionalFolios(this.folios.parent.roomChargeInvoiceRecipientId);
      }
    });

    this.$serviceBus.$on('folio.reload', () => {
      this.updateFolio();
    });

    this.updateFolios();
    this.updateFolio();
    this.updateFolioFiles();
    this.updateReceipts();

    this.prePaymentIhsId = this.hotelSettings.details.onlineBookingSettings.prepaymentIhsId;
  },

  beforeDestroy() {
    this.clearInterval(this.updateReceiptStatusInterval);
    this.clearInterval(this.activePaymentRequestUpdateTimer);
  },

  beforeRouteLeave(to, from, next) {
    if (isEmpty(this.activePaymentProcess.payments)) {
      next();
    } else {
      this.showConfirmModal(this.$t('pageFolio.messageConfirmLeavePage'), next);
    }
  },

  methods: {
    sumBy,
    createEmail() {
      this.$router.push({ name: 'reservationFolioEmail', params: { ...this.$route.params, attachment: 'LATEST' } });
    },
    wrapPauseAutosave(func = () => {}) {
      try {
        this.as__autosave();
        this.as__pauseAutosave('folio');
        return this.setTimeout(func, 500);
      } finally {
        this.as__continueAutosave('folio');
      }
    },
    addFolio() {
      this.$store.commit('save/started', this.folioId);
      this.creatingFolio = true;
      this.axios.post(this.serviceUrls.folio.createFolio(this, this.parentId))
        .then((response) => {
          this.updateFolios();
        })
        .catch((error) => {
          this.showMessages(error.response);
        })
        .finally(() => {
          this.creatingFolio = false;
          this.$store.commit('save/finished', this.folioId);
        });
    },
    printReceipt(receiptHolderId, seq) {
      this.printHTML(
        window.getOldUIPath(
          this.hotelSettings.tenant.subdomain,
          this.hotelSettings.hotel.id,
          `/rest/ui/backend/hotel/${this.$route.params.hotelId}/print/receipt?parentId=${this.parentId}&receiptHolderId=${receiptHolderId}&receiptSeq=${seq}&displayMode=print`,
          window.getToken(this.$route.params.hotelId),
          null,
          true,
        ),
      );
    },
    addPayment() {
      if (this.paymentStatus.balance > 0) {
        this.showConfirmModal(
          this.$t('pageFolio.confirmCreditNote', { balance: Math.abs(this.paymentStatus.balance), currency: this.hotelSettings.details.currency }),
          this._addPayment,
        );
      } else {
        this._addPayment();
      }
    },
    _addPayment() {
      const doesCreateInvoice = this.hotelSettings.details.countryCode === 'AT' || (this.hotelSettings.details.countryCode === 'DE' && this.hasLicense('EU_DE_Registrierkasse'));
      this.wrapPauseAutosave(() => {
        this.$store.commit('save/started', this.folioId);
        this.creatingPDF = true;
        this.axios.post(this.serviceUrls.folio.addPayment(this, this.parentId, this.folioId), this.activePaymentProcess)
          .then((response) => {
            this.showSuccessMessage();
            this.activePaymentProcess = {
              id: uuid.v4(),
              payments: [],
            };
            this.updateFolio();
            this.updateFolioFiles()
              .then((resp) => {
                if (doesCreateInvoice) {
                  this.printPDF(this.getLatestInvoiceFileURL('Final'));
                }
              });
            this.updateFolios();
          })
          .catch((error) => {
            this.showMessages(error.response);
          })
          .finally(() => {
            this.$store.commit('save/finished', this.folioId);
            this.creatingPDF = false;
          });
      });
    },
    createInvoice() {
      if (this.paymentStatus.balance > 0) {
        this.showConfirmModal(
          this.$t('pageFolio.confirmCreditNote', { balance: Math.abs(this.paymentStatus.balance), currency: this.hotelSettings.details.currency }),
          () => {
            this.pdfAction(
              'createInvoice',
              'Final',
            );
          },
        );
      } else {
        this.pdfAction(
          'createInvoice',
          'Final',
          () => {
            this.updateFolios();
          },
        );
      }
    },
    addPaymentCreateInvoice() {
      if (this.paymentStatus.balance > 0) {
        this.showConfirmModal(
          this.$t('pageFolio.confirmCreditNote', { balance: Math.abs(this.paymentStatus.balance), currency: this.hotelSettings.details.currency }),
          this._addPaymentCreateInvoice,
        );
      } else {
        this._addPaymentCreateInvoice();
      }
    },
    _addPaymentCreateInvoice() {
      this.wrapPauseAutosave(() => {
        this.$store.commit('save/started', this.folioId);
        this.creatingPDF = true;
        this.axios.post(this.serviceUrls.folio.addPaymentCreateInvoice(this, this.parentId, this.folioId), this.activePaymentProcess)
          .then((response) => {
            this.showSuccessMessage();
            this.activePaymentProcess = {
              id: uuid.v4(),
              payments: [],
            };
            this.updateFolio();
            this.updateFolioFiles()
              .then((resp) => {
                // this.printPDF(this.getLatestInvoiceFileURL(version));
              });
            this.updateFolios();
          })
          .catch((error) => {
            this.showMessages(error.response);
          })
          .finally(() => {
            this.$store.commit('save/finished', this.folioId);
            this.creatingPDF = false;
          });
      });
    },
    deletePayment(paymentId, force = false, transfer = false) {
      if (!isBoolean(force)) force = false;

      if (this.folio.prepaymentInvoice) {
        force = true;
        transfer = false;
      }

      function _deletePayment() {
        this.$store.commit('save/started', this.folioId);
        this.creatingPDF = true;

        this.axios.delete(
          this.serviceUrls.folio.deletePayment(this, this.parentId, this.folioId, paymentId),
          {
            params: {
              transfer: transfer,
            },
          },
        )
          .then((response) => {
            this.showSuccessMessage();
            this.updateFolio();
            this.updateFolioFiles();
            this.updateFolios();
          })
          .catch((error) => {
            this.showMessages(error.response);
          })
          .finally(() => {
            this.$store.commit('save/finished', this.folioId);
            this.creatingPDF = false;
          });
      }

      switch (this.hotelSettings.details.countryCode) {
        // GERMANY --> always cancel the invoice as well
        case 'DE':
          if (this.hasLicense('EU_DE_Registrierkasse')) {
            this.cancelInvoice(force, transfer);
          } else {
            _deletePayment.call(this);
          }
          break;
        // everywhere else --> allow cancellation of payment, but keep invoice (if it does exist)
        default:
          _deletePayment.call(this);
          break;
      }
    },
    addPrePayment() {
      this.showSelectPrePaymentIhsId = true;
    },
    finishPrePayment() {
      this.wrapPauseAutosave(() => {
        this.$store.commit('save/started', this.folioId);
        this.creatingPDF = true;
        this.axios.post(this.serviceUrls.folio.addPrePayment(this, this.parentId, this.folioId, this.prePaymentIhsId), this.activePaymentProcess)
          .then((response) => {
            this.showSuccessMessage();
            this.activePaymentProcess = {
              id: uuid.v4(),
              payments: [],
            };
            this.updateFolio();
            this.updateFolios();
          })
          .catch((error) => {
            this.showMessages(error.response);
          })
          .finally(() => {
            this.$store.commit('save/finished', this.folioId);
            this.creatingPDF = false;
          });
      });
    },
    finishPrePaymentInvoice() {
      this.wrapPauseAutosave(() => {
        this.$store.commit('save/started', this.folioId);
        this.axios.post(this.serviceUrls.folio.createPrePaymentInvoice(this, this.parentId, this.folioId), this.prePaymentInvoice)
          .then((response) => {
            this.showSuccessMessage();
            this.prePaymentInvoice = {
              ihsId: null,
              label: null,
              amount: 0.0,
              currency: null,
              invoiceTextBottom: null,
            };
            this.updateFolio();
            this.updateFolios();
          })
          .catch((error) => {
            this.showMessages(error.response);
          })
          .finally(() => {
            this.$store.commit('save/finished', this.folioId);
          });
      });
    },
    removeDraftPaymentTransaction(paymentTransaction) {
      this.activePaymentProcess.payments.splice(this.activePaymentProcess.payments.indexOf(paymentTransaction), 1);
    },
    getLatestInvoiceFileURL(status) {
      const latestDraftInvoiceFile = head(this.files.filter(it => it.metadata.DOCUMENT_TYPE === 'Invoice' && it.metadata.VERSION === status));

      if (isNil(latestDraftInvoiceFile)) {
        return null;
      } else if (isEmpty(this.hotelSettings.details.stationery) || this.hotelSettings.details.defaultInvoiceDocumentType === 'Display') {
        return latestDraftInvoiceFile.fileURL;
      } else {
        const printRendition = latestDraftInvoiceFile.renditions.find(it => it.renditionIdentifier === 'INVOICE_PRINT_VERSION');

        return isNil(printRendition) ? null : printRendition.fileURL;
      }
    },
    openUrl(url) {
      window.open(url, '_blank');
    },
    printPDF(url) {
      this.$serviceBus.$emit('printPDF', url);
    },
    printHTML(url) {
      this.$serviceBus.$emit('printHTML', url);
    },
    cancelInvoice(force = false, transfer = true) {
      if (!isBoolean(force)) force = false;

      if (this.folio.prepaymentInvoice) {
        if (!force) {
          this.showConfirmModal(
            this.$t('pageFolio.cancelTransferFolio.prepaymentInvoice'),
            () => this.cancelInvoice(true, false),
            this.$t('pageFolio.cancelTransferFolio.prepaymentInvoiceWarning'),
          );
          return;
        } else {
          transfer = false;
        }
      }

      if (!force) {
        switch (this.hotelSettings.details.countryCode) {
          case 'DE':
            if (this.hasLicense('EU_DE_Registrierkasse')) {
              this.showModalConfig(
                {
                  content: this.$t('pageFolio.cancelTransferFolio.content'),
                  hint: this.$t('pageFolio.cancelTransferFolio.hint'),
                  button1: {
                    color: 'orange',
                    icon: 'transfer',
                    label: this.$t('pageFolio.cancelTransferFolio.button1'),
                    onClick: () => {
                      this.cancelInvoice(true, true);
                    },
                  },
                  button2: {
                    color: 'green',
                    icon: 'save',
                    label: this.$t('pageFolio.cancelTransferFolio.button2'),
                    onClick: () => {
                      this.cancelInvoice(true, false);
                    },
                  },
                },
              );
            } else {
              this.showModalConfig(
                {
                  content: this.$t('pageFolio.cancelModifyFolio.content'),
                  hint: this.$t('pageFolio.cancelModifyFolio.hint'),
                  button1: {
                    color: 'orange',
                    icon: 'transfer',
                    label: this.$t('pageFolio.cancelModifyFolio.button1'),
                    onClick: () => {
                      this.cancelInvoice(true, true);
                    },
                  },
                  button2: {
                    color: 'green',
                    icon: 'save',
                    label: this.$t('pageFolio.cancelModifyFolio.button2'),
                    onClick: () => {
                      this.cancelInvoice(true, false);
                    },
                  },
                },
              );
            }
            return;
          case 'AT':
            this.showModalConfig(
              {
                content: this.$t('pageFolio.cancelModifyFolio.content'),
                hint: this.$t('pageFolio.cancelModifyFolio.hint'),
                warning: isEmpty(this.folio.payments) ? null : this.$t('pageFolio.cancelModifyFolio.paymentWarning'),
                button1: {
                  color: 'orange',
                  icon: 'transfer',
                  label: this.$t('pageFolio.cancelModifyFolio.button1'),
                  onClick: () => {
                    this.cancelInvoice(true, true);
                  },
                },
                button2: {
                  color: 'green',
                  icon: 'save',
                  label: this.$t('pageFolio.cancelModifyFolio.button2'),
                  onClick: () => {
                    this.cancelInvoice(true, false);
                  },
                },
              },
            );
            return;
          default:
            break;
        }
      }

      this.pdfAction('cancelInvoice', 'Final', null, { transfer: transfer });
    },
    createPDF() {
      this.pdfAction('createPDF', this.folio.status === 'Draft' ? 'Draft' : 'Final');
    },
    pdfAction(action, version, additionalUpdates = () => {}, queryParams = {}, invoiceNumber = null) {
      this.wrapPauseAutosave(() => {
        this.$store.commit('save/started', this.folioId);
        this.creatingPDF = true;
        this.axios.post(
          this.serviceUrls.folio[action](this, this.parentId, this.folioId, invoiceNumber),
          null,
          {
            params: {
              ...queryParams,
            },
          },
        )
          .then((response) => {
            this.showSuccessMessage();
            this.updateFolio();
            this.updateFolioFiles()
              .then((resp) => {
                this.printPDF(this.getLatestInvoiceFileURL(version));
              });
            this.updateFolios();
            if (!isNil(additionalUpdates)) additionalUpdates();
          })
          .catch((error) => {
            this.showMessages(error.response);
          })
          .finally(() => {
            this.$store.commit('save/finished', this.folioId);
            this.creatingPDF = false;
          });
      });
    },
    addPaymentTransaction() {
      const paymentTransaction = this.$refs.createPayment.value;

      if (paymentTransaction.paymentMethod === 'Voucher' && isEmpty(paymentTransaction.transactionReference)) {
        this.showErrorMessage(this.$t('pageFolio.errorVoucherNumberRequired'));
        return;
      }

      this.activePaymentProcess.payments.push(paymentTransaction);
      this.$refs.createPayment.reInitPayment();
      this.showCreatePaymentModal = false;
    },
    addTransaction() {
      if (this.$store.getters['save/saveInProgress']) return;

      const transaction = this.$refs.createTransaction.value;

      if (isNil(transaction.code) || isEmpty(transaction.code.id)) {
        this.showErrorMessage(this.$t('pageFolio.errorTransactionTypeRequired'));
        return;
      }

      if (transaction.code.type === 'InHouseService') {
        const ihs = this.findHotelSettingById('inHouseServices', transaction.code.id);

        switch (ihs.fiscalizationChargeType) {
          case 'VoucherSale':
          case 'VoucherRedeem':
          case 'CouponSale':
          case 'CouponRedeem':
            if (isEmpty(transaction.transactionReferenceNumber)) {
              this.showErrorMessage(this.$t('pageFolio.errorVoucherNumberRequired'));
              return;
            }
            break;
          default:
            break;
        }
      }

      this.$store.commit('save/started', this.folioId);
      this.axios.post(this.serviceUrls.folio.addTransaction(this, this.parentId, this.folioId), transaction)
        .then((response) => {
          this.showSuccessMessage();
          this.showCreateTransactionModal = false;
          this.$refs.createTransaction.reInitTransaction();
          this.updateFolio();
        })
        .catch((error) => {
          this.showMessages(error.response);
        })
        .finally(() => {
          this.$store.commit('save/finished', this.folioId);
        });
    },
    updateTransaction() {
      if (this.$store.getters['save/saveInProgress']) return;

      const transaction = this.$refs.updateTransaction.value;

      if (transaction.code.type === 'InHouseService') {
        const ihs = this.findHotelSettingById('inHouseServices', transaction.code.id);

        switch (ihs.fiscalizationChargeType) {
          case 'VoucherSale':
          case 'VoucherRedeem':
          case 'CouponSale':
          case 'CouponRedeem':
            if (isEmpty(transaction.transactionReferenceNumber)) {
              this.showErrorMessage(this.$t('pageFolio.errorVoucherNumberRequired'));
              return;
            }
            break;
          default:
            break;
        }
      }
      this.$store.commit('save/started', this.folioId);
      this.axios.put(this.serviceUrls.folio.updateTransaction(this, this.parentId, this.folioId, transaction.id), transaction)
        .then((response) => {
          this.showSuccessMessage();
          this.editTransaction = null;
          this.updateFolio();
        })
        .catch((error) => {
          this.showMessages(error.response);
        })
        .finally(() => {
          this.$store.commit('save/finished', this.folioId);
        });
    },
    doSplitTransaction() {
      if (this.$store.getters['save/saveInProgress']) return;

      const transaction = this.$refs.splitTransaction.value;
      const split = this.$refs.splitTransaction.split;

      this.$store.commit('save/started', this.folioId);
      this.axios.put(this.serviceUrls.folio.splitTransaction(this, this.parentId, this.folioId, transaction.id), split)
        .then((response) => {
          this.showSuccessMessage();
          this.splitTransaction = null;
          this.updateFolio();
        })
        .catch((error) => {
          this.showMessages(error.response);
        })
        .finally(() => {
          this.$store.commit('save/finished', this.folioId);
        });
    },
    loadBillingGuestProfile() {
      if (isEmpty(this.folio.billingProfileId)) {
        this.billingGuestProfile = null;
      } else {
        this.axios.get(this.serviceUrls.guest.getFull(this, this.folio.billingProfileId))
          .then((response) => {
            this.billingGuestProfile = response.data.data;
          })
          .catch((error) => {
            this.billingGuestProfile = null;
          });
      }
    },
    cancelTransaction(transactionId) {
      this.axios.delete(this.serviceUrls.folio.deleteTransaction(this, this.parentId, this.folioId, transactionId))
        .then((response) => {
          this.updateFolio();
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    undoCancelTransaction(transactionId) {
      this.axios.put(this.serviceUrls.folio.restoreTransaction(this, this.parentId, this.folioId, transactionId))
        .then((response) => {
          this.updateFolio();
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    updateReservation() {
      return this.axios
        .get(this.serviceUrls.reservation.get(this, this.folios.parent.id))
        .then((response) => {
          this.reservation = response.data.data;
        })
        .catch((error) => {
          this.reservation = null;
        });
    },
    updateFolio() {
      this.axios.get(this.serviceUrls.folio.get(this, this.parentId, this.folioId))
        .then((response) => {
          this.folio = response.data.data;

          if (isEmpty(this.folio.billingProfileId)) {
            this.folio.billingProfileId = this.folio.primaryGuestProfileId;
          }
        });

      this.axios.get(this.serviceUrls.folio.paymentStatus(this, this.parentId, this.folioId))
        .then((response) => {
          this.paymentStatus = response.data.data;
        });

      this.updateReceipts();
    },
    updateFolioFiles() {
      return this.axios.get(this.serviceUrls.folio.correspondence(this, this.parentId, this.folioId))
        .then((response) => {
          this.files = reverse(response.data.data);
        });
    },
    updateFolios() {
      return this.axios.get(this.serviceUrls.folio.list(this, this.parentId))
        .then((response) => {
          this.$serviceBus.$emit('folio.list', {
            parentId: this.parentId,
            data: response.data.data,
          });

          if (this.folios.parent.type === 'RoomReservation') {
            this.updateReservation();
          } else {
            this.reservation = null;
          }
        });
    },
    updateAdditionalFolios(parentId) {
      return this.axios.get(this.serviceUrls.folio.list(this, parentId))
        .then((response) => {
          this.$serviceBus.$emit('additionalFolio.list', {
            parentId: this.parentId,
            data: response.data.data,
          });
        });
    },
    updateReceipts() {
      switch (this.hotelSettings.details.countryCode) {
        case 'DE':
          if (this.hasLicense('EU_DE_Registrierkasse')) {
            this.axios.get(this.serviceUrls.receipt.list(this, this.parentId, this.folioId))
              .then((response) => {
                this.receipts = response.data.data;
              });
          }
          break;
        default:
          break;
      }
    },
    confirmEditPayment() {
      const paymentTransaction = this.editPaymentTransaction;

      if (paymentTransaction.paymentMethod === 'Voucher' && isEmpty(paymentTransaction.transactionReference)) {
        this.showErrorMessage(this.$t('pageFolio.errorVoucherNumberRequired'));
        return;
      }

      this.activePaymentProcess.payments = this.activePaymentProcess.payments.map((it) => {
        if (it.id === paymentTransaction.id) return paymentTransaction;
        else return it;
      });

      this.editPaymentTransaction = null;
    },
    onClickEditPaymentTransaction(paymentTransaction) {
      this.editPaymentTransaction = cloneDeep(paymentTransaction);
    },
    regenerateInvoicePdf(invoiceNumber) {
      this.pdfAction('recreatePDF', 'Final', {}, {}, invoiceNumber);
    },
    previewTerminal(terminalId = null) {
      if (isEmpty(terminalId)) terminalId = this.hotelSettings.interfaces.stripe.defaultTerminalId;
      if (isEmpty(terminalId)) {
        this.showErrorMessage(this.$t('pageFolio.errorNoTerminalSelected'));
        return;
      }

      this.axios.post(this.serviceUrls.folio.terminal.preview(this, this.parentId, this.folioId, terminalId))
        .then((response) => {
          this.showSuccessMessage();
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    cancelTerminal(terminalId = null) {
      if (isEmpty(terminalId)) terminalId = this.hotelSettings.interfaces.stripe.defaultTerminalId;
      if (isEmpty(terminalId)) {
        this.showErrorMessage(this.$t('pageFolio.errorNoTerminalSelected'));
        return Promise.reject();
      }

      return this.axios.post(this.serviceUrls.folio.terminal.cancel(this, this.parentId, this.folioId, terminalId))
        .then((response) => {
          this.showSuccessMessage();
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    requestPayment(terminalId = null) {
      let doesCreateInvoice = true;

      if (isEmpty(terminalId)) terminalId = this.hotelSettings.interfaces.stripe.defaultTerminalId;
      if (isEmpty(terminalId)) {
        this.showErrorMessage(this.$t('pageFolio.errorNoTerminalSelected'));
        return;
      }

      this.wrapPauseAutosave(() => {
        this.$store.commit('save/started', this.folioId);
        this.creatingPDF = true;
        this.axios.post(this.serviceUrls.folio.terminal.payment(this, this.parentId, this.folioId, terminalId))
          .then((response) => {
            this.showSuccessMessage();
            this.activePaymentProcess = {
              id: uuid.v4(),
              payments: [],
            };
            this.folio = response.data.data;

            if (isEmpty(this.folio.billingProfileId)) {
              this.folio.billingProfileId = this.folio.primaryGuestProfileId;
            }
            this.updateFolios();
          })
          .catch((error) => {
            this.showMessages(error.response);
          })
          .finally(() => {
            this.$store.commit('save/finished', this.folioId);
            this.creatingPDF = false;
          });
      });
    },
    unlockFolio() {
      this.showConfirmModal(
        this.$t('pageFolio.confirmUnlockFolio'),
        this._unlockFolio,
      );
    },
    _unlockFolio() {
      this.axios.post(this.serviceUrls.folio.unlockFolio(this, this.parentId, this.folioId))
        .then((response) => {
          this.showSuccessMessage();
          this.updateFolio();
          this.updateFolios();
        })
        .catch((error) => {
          this.showMessages(error.response);
        })
    },
    updatePaymentRequest(paymentRequestId) {
      if (isEmpty(paymentRequestId) || this.activePaymentRequest === false) {
        return;
      }
      this.axios.get(this.serviceUrls.paymentRequest.get(this, paymentRequestId)).then((response) => {
        this.activePaymentRequest = response.data.data;
        if (!isNil(this.activePaymentRequest) && ['Failed', 'Unknown', 'Cancelled'].includes(this.activePaymentRequest.status)) {
          this.updateFolio();
        }
        if (!isNil(this.activePaymentRequest) && this.activePaymentRequest.folioPaymentDetails.every(it => it.posted)) {
          this.updateFolio();
        }
      });
    },
    id2number: function (value) {
      if (isEmpty(value)) return '';
      return last(value.split('::'));
    },
    cancelPaymentRequest(paymentRequestId) {
      this.cancelTerminal()
        .then(() => {
          this.axios.delete(this.serviceUrls.paymentRequest.delete(this, paymentRequestId))
            .then((response) => {
              this.showSuccessMessage();
              this.cancelTerminal();
              this.setTimeout(this.updateFolio, 1500);
            })
            .catch((error) => {
              this.showMessages(error.response);
            });
        })
    },
  },

};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';
</style>



// WEBPACK FOOTER //
// src/components/pages/PageFolio.vue